import React, { PropsWithChildren } from "react";

const Container = ({ children }: PropsWithChildren<{}>) => {
  return <div className="container d-flex flex-column justify-content-center">{children}</div>;
};

export default Container;
